var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26918_12217)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3571 15.5H25.1429V11.6429C25.1429 11.2878 24.855 11 24.5 11H11.6429C11.2878 11 11 11.2878 11 11.6429V26.4286C11 27.8487 12.1513 29 13.5714 29H26.4286C27.8487 29 29 27.8487 29 26.4286V16.1428C29 15.7878 28.7122 15.5 28.3571 15.5ZM16.1428 14.2134H20C20.355 14.2134 20.6428 14.5011 20.6428 14.8561C20.6428 15.211 20.355 15.4988 20 15.4988H16.1428C15.7878 15.4988 15.5 15.211 15.5 14.8561C15.5 14.5011 15.7878 14.2134 16.1428 14.2134ZM14.2135 26.4282H21.9278C22.2829 26.4282 22.5707 26.1405 22.5707 25.7855C22.5707 25.4306 22.2829 25.1428 21.9278 25.1428H14.2135C13.8585 25.1428 13.5707 25.4306 13.5707 25.7855C13.5707 26.1405 13.8585 26.4282 14.2135 26.4282ZM21.9278 23.8568H14.2135C13.8585 23.8568 13.5707 23.569 13.5707 23.2141C13.5707 22.8591 13.8585 22.5714 14.2135 22.5714H21.9278C22.2829 22.5714 22.5707 22.8591 22.5707 23.2141C22.5707 23.569 22.2829 23.8568 21.9278 23.8568ZM14.2135 21.2854H21.9278C22.2829 21.2854 22.5707 20.9976 22.5707 20.6427C22.5707 20.2877 22.2829 20 21.9278 20H14.2135C13.8585 20 13.5707 20.2877 13.5707 20.6427C13.5707 20.9976 13.8585 21.2854 14.2135 21.2854ZM21.9278 18.7139H14.2135C13.8585 18.7139 13.5707 18.4262 13.5707 18.0712C13.5707 17.7163 13.8585 17.4285 14.2135 17.4285H21.9278C22.2829 17.4285 22.5707 17.7163 22.5707 18.0712C22.5707 18.4262 22.2829 18.7139 21.9278 18.7139ZM26.4282 27.7143C27.1381 27.7143 27.7135 27.1386 27.7135 26.4286H27.7136V16.7857H25.1429V26.4286C25.1429 27.1386 25.7183 27.7143 26.4282 27.7143Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26918_12217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.c0346c89bbb933a55060acbc99ac2a06.svg";
export { ForwardRef as ReactComponent };